<template>
  <v-layout
    :class="(mobile ? 'search-div-mobile' : '')+ ' search-div'"
    wrap elevation-3
  >
    <div style="position: relative; left: 10000px; top: -70px;">
      <a name="searchfilters" />
    </div>
    <v-flex xs12 class="search-form-title-red">{{ $t('check_in') }}</v-flex>
    <v-flex cx12>
      <!--v-text-field
        color="purple"
        solo
        placeholder="Check in date"
        append-icon="mdi-calendar-today"
        hide-details
      / -->
      <input type="text"
        v-model="searchFilters.dateStart"
        autocomplete="off"
        :class="'input_full filter-calendar hasDatepicker ' + (mobile ? 'mobile-date' : '')"
        name="checkin"
        id="checkin"
        value=""
        :placeholder="$t('saabumise_kuupäev')"
        @focus="dateStartFocus($event)"
      >
      <div style="display:none;">!{{ searchFilters.dateStart }}</div>
      <calendar-date-picker
        v-if="showSearchPickerFor === 'dateStart'"
        v-model="searchFilters.dateStart"
        fieldName="dateStart"
        :left="calendarLeftPosition"
        :mobile-padding="16"
        @update="updatePickerDate"
        :for-search-form="true"
      />
    </v-flex>
    <v-flex xs12 class="search-form-title-red">{{ $t('check_out') }}</v-flex>
    <v-flex cx12>
      <!-- v-text-field
        hide-details
        solo
        placeholder="Check out date"
        append-icon="mdi-calendar"
      / -->
      <input
        v-model="searchFilters.dateEnd"
        autocomplete="off"
        type="text"
        :class="'input_full filter-calendar filter-bottom-margin hasDatepicker ' + (mobile ? 'mobile-date' : '')"
        name="checkout"
        id="checkout"
        value=""
        :placeholder="$t('lahkumise_kuupäev')"
        @focus="dateEndFocus($event)"
      >
      <calendar-date-picker
        v-if="showSearchPickerFor === 'dateEnd'"
        v-model="searchFilters.dateEnd"
        :starting-from="searchFilters.dateStart"
        field-name="dateEnd"
        :left="calendarLeftPosition"
        :mobile-padding="16"
        @update="updatePickerDate"
        :for-search-form="true"
      />
    </v-flex>
    <v-flex xs12 class="search-form-title">{{ $t('asukoht') }}:</v-flex>
    <v-flex cx12>
      <!--v-combobox
        hide-details
        solo
        placeholder="- Costa del Sol -"
        :items="['- Costa del Sol -','Torremolinos','Benalmádena','Fuengirola','Mijas','Marbella','Estepona','Manilva']"
      /-->
      <select v-model="searchFilters.region"
        :class="'input_full filter-select-padding ' + (mobile ? 'mobile-field' : '')"
        name="region">
        <option value="all">- Costa del Sol -</option>
        <option
          v-for="(objectRegion, ori) in objectRegions.filter(objectRegion => !objectRegion.hidden)"
          :key="ori"
          :value="objectRegion.id"
        >
          {{ objectRegion.regionName }}
        </option>
      </select>
    </v-flex>
    <v-flex xs12 class="search-form-title">{{ $t('majutuse_tüüp') }}:</v-flex>
    <v-flex cx12>
      <!-- v-combobox
        hide-details
        solo
        placeholder="- show all -"
        :items="['- show all -','Apartment','House']"
      / -->
      <select v-model="searchFilters.type"
        :class="'input_full filter-select-padding ' + (mobile ? 'mobile-field' : '')"
        name="type_id">
        <option value="all">- {{ $t('näita_kõik') }} -</option>
        <option value="5bc8706e35e8e07d222a25ac">{{ $t('type_apartment') }}</option>
        <option value="5bc8707335e8e07d222a25ad">{{ $t('type_house') }}</option>
      </select>
    </v-flex>
    <v-flex xs12 class="search-form-title">{{ $t('inimeste_arv') }}:</v-flex>
    <v-flex xs12>
      <!-- v-combobox
        hide-details
        solo
        placeholder="- s -"
        :items="['1 person','- 2 persons -','3 persons']"
      /-->
      <select v-model="searchFilters.maxPeople_from"
        :class="'input_full filter-select-padding ' + (mobile ? 'mobile-field' : '')"
        name="guests"
      >
        <option value="1">
        1 {{ $t('inimene') }}
        </option>
        <option value="2">
        - 2 {{ $t('inimest') }} -
        </option>
        <option
          v-for="(nr, index) in [...Array(18)]"
          :key="index"
          :value="index + 3"
        >
        {{ (index + 3) }} {{ $t('inimest') }}
        </option>
      </select>
    </v-flex>
    <!-- v-flex v-if="searchFilters.favorites === 1" xs12 class="search-form-title">
      {{ $t('favorite') }}:
    </v-flex>
    <v-flex v-if="searchFilters.favorites === 1" xs12>
      <select
        v-model="searchFilters.favorites"
        :class="'input_full filter-select-padding ' + (mobile ? 'mobile-field' : '')" name="terrace">
        <option value="0">{{ $t('ei') }}</option>
        <option value="1">{{ $t('jah') }}</option>
      </select>
    </v-flex -->
    <template v-if="detailedSearch">
      <hr>
      <v-flex xs12 class="search-form-title">
        {{ $t('weekly_price') }}:
      </v-flex>
      <v-flex xs12>
        <select
          v-model="searchFilters.priceRange"
          :class="'input_full filter-select-padding ' + (mobile ? 'mobile-field' : '')"
          name="price"
        >
          <option value="all">- {{ $t('näita_kõik') }} -</option>
          <option value="1">... - 500 €</option>
          <option value="2">500 € - 1000 €</option>
          <option value="3">1000 € - ...</option>
        </select>
      </v-flex>
      <v-flex xs12 class="search-form-title">
        {{ $t('magamistubade_arv') }}:
      </v-flex>
      <v-flex xs12>
        <select v-model="searchFilters.bedroomsCount"
          :class="'input_full filter-select-padding ' + (mobile ? 'mobile-field' : '')"
          name="bedrooms">
					<option value="all">- {{ $t('näita_kõik') }} -</option>
					<option value="0">{{ $t('stuudiokorter') }}</option>
					<option value="1">1 {{ $t('magamistuba') }}</option>
					<option value="2">2 {{ $t('magamistuba') }}</option>
					<option value="3">3 {{ $t('magamistuba') }}</option>
					<option value="4">4+ {{ $t('magamistuba') }}</option>
				</select>
      </v-flex>
      <v-flex xs12 class="search-form-title">
        {{ $t('vannitubade_arv') }}:
      </v-flex>
      <v-flex xs12>
        <select
          v-model="searchFilters.bathroomCount"
          :class="'input_full filter-select-padding ' + (mobile ? 'mobile-field' : '')"
          name="bathrooms">
					<option value="all">- {{ $t('näita_kõik') }} -</option>
					<option value="1">1 {{ $t('vannituba') }}</option>
					<option value="2">2 {{ $t('vannituba') }}</option>
					<option value="3">3+ {{ $t('vannitoaga') }}</option>
				</select>
      </v-flex>
      <v-flex xs12 class="search-form-title">
        {{ $t('parking') }}:
      </v-flex>
      <v-flex xs12>
        <select
          v-model="searchFilters.parking"
          :class="'input_full filter-select-padding ' + (mobile ? 'mobile-field' : '')"
          name="parking">
					<option value="all">- {{ $t('näita_kõik') }} -</option>
					<option value="1">{{ $t('jah') }}</option>
				</select>
      </v-flex>
      <v-flex xs12 class="search-form-title">
        {{ $t('bassein') }}:
      </v-flex>
      <v-flex xs12>
        <select
          v-model="searchFilters.pool"
          :class="'input_full filter-select-padding ' + (mobile ? 'mobile-field' : '')"
          name="pool">
					<option value="all">- {{ $t('näita_kõik') }} -</option>
					<option value="1">{{ $t('jah') }}</option>
				</select>
      </v-flex>
      <v-flex xs12 class="search-form-title">
        {{ $t('terrass') }}:
      </v-flex>
      <v-flex xs12>
        <select
          v-model="searchFilters.terrace"
          :class="'input_full filter-select-padding ' + (mobile ? 'mobile-field' : '')" name="terrace">
					<option value="all">- {{ $t('näita_kõik') }} -</option>
					<option value="1">{{ $t('jah') }}</option>
				</select>
      </v-flex>
      <v-flex xs12 class="search-form-title">
        {{ $t('konditsioneer') }}:
      </v-flex>
      <v-flex xs12>
        <select
          v-model="searchFilters.aircon"
          :class="'input_full filter-select-padding ' + (mobile ? 'mobile-field' : '')" name="aircon">
					<option value="all">- {{ $t('näita_kõik') }} -</option>
					<option value="1">{{ $t('jah') }}</option>
				</select>
      </v-flex>
      <v-flex xs12 class="search-form-title">
        {{ $t('lemmikloomad') }}:
      </v-flex>
      <v-flex xs12>
        <select
          v-model="searchFilters.pets"
          :class="'input_full filter-select-padding ' + (mobile ? 'mobile-field' : '')" name="pets">
					<option value="all">- {{ $t('näita_kõik') }} -</option>
					<option value="1">{{ $t('jah') }}</option>
				</select>
      </v-flex>
      <v-flex xs12 class="search-form-title">
        CSR ID:
      </v-flex>
      <v-flex xs12>
        <input
          v-model="searchFilters.csrId"
          type="text" :class="'input_full filter-select-padding ' + (mobile ? 'mobile-field' : '')" name="costaid" value=""
          @keyup.enter="searchFormSubmit"
        >
      </v-flex>
    </template>
    <v-flex xs12 mt-3>
      <input
        type="button"
        @click.prevent="searchFormSubmit"
        :value="$t('otsi')"
        :class="'input_full filter-submit ' + (mobile ? 'mobile-button' : '')"
        name="filter_objects"
      >
    </v-flex>
    <v-flex
      v-if="!detailedSearch"
      xs12 mt-2
      @click="detailedSearch = true"
    >
      <div style="text-align:center;cursor:pointer;font-size:12px;padding:5px 0 0 0;">
        {{ $t('täpsem_otsing') }}<br>
        <img src="/img/filter-open.png" class="filter-parts" style="padding-top:5px;">
      </div>
    </v-flex>
    <v-flex
      v-if="detailedSearch"
      xs12 mt-2
      @click="detailedSearch = false"
    >
      <div style="text-align:center;cursor:pointer;">
        {{ $t('täpsem_otsing') }}<br>
        <img src="/img/filter-close.png" class="filter-parts">
      </div>
    </v-flex>
    <v-flex
      xs12 mt-2
      v-if="searchConditionsChanged"
      @click="clearSearch()"
      class="search-clear"
    >
      {{ $i18n.t('clear') }}
    </v-flex>
  </v-layout>
</template>

<script>
import sharedMethods from './../methods/sharedMethods'
import CalendarDatePicker from './CalendarDatePicker'
import { createHelpers } from 'vuex-map-fields'
import state from './../state.js'
const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField'
})

export default {
  name: 'SearchForm',

  components: {
    CalendarDatePicker
  },

  computed: {
    ...mapFields(Object.keys(state)),

    searchConditionsChanged () {
      // console.log('searchConditionsChanged')
      // console.log( JSON.stringify(this.searchFilters), JSON.stringify(this.filterDefaultValues), JSON.stringify(this.searchFilters) !== JSON.stringify(this.filterDefaultValues))
      // console.log('this.filterDefaultValues', this.filterDefaultValues)
      // console.log('this.searchFilters', this.searchFilters)
      let filtersWithoutFavoritesSet = JSON.parse(JSON.stringify(this.searchFilters))
      filtersWithoutFavoritesSet.favorites = 0
      return JSON.stringify(filtersWithoutFavoritesSet) !== JSON.stringify(this.filterDefaultValues)
    },

    calendarLeftPosition () {
      return this.mobile ? '-15px' : '-35px'
    }
  },

  methods: {
    ...sharedMethods,

    dateStartFocus (e) {
      e.srcElement.blur()
      this.showSearchPickerFor = 'dateStart'
    },

    dateEndFocus (e) {
      e.srcElement.blur()
      this.showSearchPickerFor = 'dateEnd'
    }
  }
}
</script>

<style scoped>
.search-clear {
  color: grey;
  font-size: 14px;
  cursor: pointer;
  text-align: right;
  padding-right: 10px;
}
</style>
